import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { GenericService } from '../../common/services/GenericServices';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { IncidenceptService } from 'src/app/ceq/incidence/incidencept/incidencept.service';
import { Level } from '../../common/models/Level.Model';
import { Unit } from '../../common/models/Unit.Model';
import { Dict } from '../../common/models/Dict.Model';
import { User } from '../models/User.Model';
import { SettingsService } from 'src/app/core/settings/settings.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalFunctionsService {
  /**
   *Coleccion de canales suscritos
   */
  private notifyChannels: subjectType[] = [];

  /**
   * Usuario logueado
   */
  userLogin: User;

  constructor(
    private genericService: GenericService,
    private incptService: IncidenceptService,
    private router: Router
  ) {
  }


  /**
   * Returns the only one ParentId object from a unitId given
   * USE: Detail catalog components
   * @param unitId
   */
  GetParentId(unitId: number): Observable<Unit> {
    let url = `unit/${unitId}?$select=ParentId`;
    return this.genericService.getRequest(url, {});
  }

  /**
   * Returns a Unit list with the level parent
   * USE: Catalogs
   * @param userId
   * @param level
   */
  GetParentList(userId: number, level: string): Observable<Unit[]> {
    let url = `userprofile/level/${userId}/${level}`;
    return this.genericService.getRequest(url, {}, 0);
  }

  /**
   * Returns the parent level from a node
   * USE: Catalogs
   * @param orgId
   * @param level
   */
  GetParentLevel(orgId: number, level: string): Observable<Level> {
    let url = `level/parent/${orgId}/${level}`;
    return this.genericService.getRequest(url, {}, 0);
  }

  /**
   * Returns a date string to set input date
   * @param minD
   * @param rest
   * @param minus
   */
  getStringDate(minD: Date, rest: Boolean, minus: number): string {
    var minS: string;
    var dayDate: number;
    var dayWeek: number;
    var monthDate: number;
    var dayS: string;
    var monthS: string;
    var onemore: number = 1;

    dayDate = minD.getDate();
    monthDate = minD.getMonth();
    dayWeek = minD.getDay();

    if (rest) {
      if (minus < 7 && dayWeek - minus <= 0) {
        minus = minus + 1;
      }

      if (dayDate - minus > 0) {
        dayDate = minD.getDate() - minus
      } else {
        onemore = 0;
        if (monthDate == 2) {
          dayDate = 28 + (minD.getDate() - minus);
        }
        if (monthDate == 4 || monthDate == 6 || monthDate == 9 || monthDate == 11) {
          dayDate = 30 + (minD.getDate() - minus);
        }
        if (monthDate == 1 || monthDate == 3 || monthDate == 5 || monthDate == 7 || monthDate == 8 || monthDate == 10 || monthDate == 0) {
          dayDate = 31 + (minD.getDate() - minus);
        }
      }
    }

    if (dayDate < 10) {
      dayS = '0' + dayDate.toString();
    } else {
      dayS = dayDate.toString();
    }

    if (monthDate + 1 < 10) {
      monthS = '0' + (monthDate + onemore).toString();
    } else {
      monthS = (monthDate + onemore).toString();
    }

    minS = minD.getFullYear() + '-' + monthS + '-' + dayS;
    return minS;
  }

  /**
   * Returns enviroment published
   * USE: Identify environment
   */
  getEnvironment(): Observable<Dict> {
    let url = `security/environment`;
    return this.genericService.getRequest(url, {});
  }
  /**
   * Returns Current CEQ Version
   * USE: Refresh Web Client.
   */
  getCeqVersion(): Observable<Dict> {
    let url = `security/version`;
    return this.genericService.getRequest(url, {});
  }

  //Methods
  isNullOrWhitespace(input: string) {
    if (typeof input === 'undefined' || input == null) return true;
    return input.replace(/\s/g, '').length < 1;
  }

  currencyFormatter(params) {
    var nf = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return nf.format(params);
  }

  decimalFormatter(params) {
    var nf = new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return nf.format(params);
  }

  separatorFormatter(params) {
    var nf = new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return nf.format(params);
  }

  /**
   * Se validan procesos que bloquean la operación
   * @returns 
   */
  canOperate() {
    // Se bloquea la operación si el nodo principal del usuario tiene autorizaciones pendientes
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    if (this.userLogin.UnitId > 10000) {
      let ceveid = this.userLogin.UnitId;
      this.incptService.hasDataComplementaryPending(ceveid).subscribe(resp => {
        if (resp > 0) {
          Swal.fire({
            title: '<h2 style="color:beige;">Datos Complementarios Pendientes</h2>',
            html: '<label style="color:bisque;">Tiene que enviar a autorizar los Datos complementarios para seguir operando.</label>',
            confirmButtonText: 'Aceptar',
            background: '#000',
            allowOutsideClick: false,
            showClass: {
              popup: `animate__animated
                      animate__fadeInUp
                      animate__faster`
            },
            hideClass: {
              popup: `animate__animated
                      animate__fadeOutDown
                      animate__faster`
            }
          });
          this.router.navigate([`/incidence/inc-pt-ceve/0`]);
        }
      });

    }
  }

  /**Valida remisiones FSBR pendientes */
  hasFSBRPending() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    if (this.userLogin.UnitId > 10000) {
      this.incptService.hasFSBRRemissionPending().subscribe(resp => {
        if (resp.Pending) {
          Swal.fire({
            title: '<h2 style="color:beige;">Rechazos Pendientes</h2>',
            html: `<label style="color:bisque;">${resp.Message}</label>`,
            confirmButtonText: 'Aceptar',
            background: '#000',
            allowOutsideClick: false,
            showClass: {
              popup: `animate__animated
                            animate__fadeInUp
                            animate__faster`
            },
            hideClass: {
              popup: `animate__animated
                            animate__fadeOutDown
                            animate__faster`
            }
          });
          this.router.navigate([`/management/remission-status`]);
        }

      });
    }
  }

  /**
   * Generate a toast message
   * @param msg: string to show in toast
   * @param icons: type of toast 
   * @param duration: time in ms
   */
  async messageToast(msg: string, icons: toastIcon, duration: number = 4000) {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    let colorMessage = this.userLogin.ColorMessage;
    let Toast;
    if (icons === 'loading') {
      let textColor = colorMessage === false ? 'darkblue' : 'white';
      Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: false,
        html: `
          <div style="margin-bottom: 16px; text-align: center; margin: -30px; padding: 0px;">
            <table style="margin-left: 0px;"><tr>
            <td>
              <img src="../assets/img/ositoanim2.gif" alt="ositoanim2.gif" style="display: block; margin: 0 auto;" height="100" />
            </td>
            <td>
              <h4><label style="color: ${textColor};">&nbsp;&nbsp;${msg}&nbsp;&nbsp;</label></h4>
            </td>
            </tr></table>
          </div>
        `,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      Toast.fire({
        //title: '<label style="color: white">PROCESANDO...</label>',
        background: colorMessage === false ? 'WhiteSmoke' : '#10a0e7ff'
      });
    } else {
      Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
      });
    }
    if (icons === 'error') {
      let textColor = colorMessage === false ? 'Crimson' : 'white';
      await Toast.fire({
        //title: '<label style="color: white">ERROR</label>',
        background: colorMessage === false ? 'WhiteSmoke' : 'Crimson',
        html: `
          <div style="margin-bottom: 16px; text-align: center; margin: -30px; padding: 0px;">
            <table style="margin-left: 0px;"><tr>
            <td>
              <img src="../assets/img/ositoanim2.gif" alt="ositoanim2.gif" style="display: block; margin: 0 auto;" height="100" />
            </td>
            <td>
              <h4><label style="color: ${textColor};">&nbsp;&nbsp;${msg}&nbsp;&nbsp;</label></h4>
            </td>
            </tr></table>
          </div>
        `
      });
    }
    if (icons === 'warning') {
      let textColor = colorMessage === false ? 'DarkOrange' : 'white';
      await Toast.fire({
        //title: `<label style="color: white">${msg}</label>`,
        background: colorMessage === false ? 'WhiteSmoke' : 'DarkOrange',
        html: `
          <div style="margin-bottom: 16px; text-align: center; margin: -30px; padding: 0px;">
            <table style="margin-left: 0px;"><tr>
            <td>
              <img src="../assets/img/ositoanim2.gif" alt="ositoanim2.gif" style="display: block; margin: 0 auto;" height="100" />
            </td>
            <td>
              <h4><label style="color: ${textColor};">&nbsp;&nbsp;${msg}&nbsp;&nbsp;</label></h4>
            </td>
            </tr></table>
          </div>
        `
      });
    }
    if (icons === 'info') {
      let textColor = colorMessage === false ? 'SteelBlue' : 'white';
      await Toast.fire({
        //title: '<label style="color: white">AVISO</label>',
        background: colorMessage === false ? 'WhiteSmoke' : 'SteelBlue',
        html: `
          <div style="margin-bottom: 16px; text-align: center; margin: -30px; padding: 0px;">
            <table style="margin-left: 0px;"><tr>
            <td>
              <img src="../assets/img/ositoanim2.gif" alt="ositoanim2.gif" style="display: block; margin: 0 auto;" height="100" />
            </td>
            <td>
              <h4><label style="color: ${textColor};">&nbsp;&nbsp;${msg}&nbsp;&nbsp;</label></h4>
            </td>
            </tr></table>
          </div>
        `
      });
    }
    if (icons === 'success') {
      let textColor = colorMessage === false ? 'DarkGreen' : 'white';
      await Toast.fire({
        //title: '<label style="color: white">CORRECTO</label>',
        background: colorMessage === false ? 'WhiteSmoke' : 'MediumSeaGreen',
        html: `
          <div style="margin-bottom: 16px; text-align: center; margin: -30px; padding: 0px;">
            <table style="margin-left: 0px;"><tr>
            <td>
              <img src="../assets/img/ositoanim2.gif" alt="ositoanim2.gif" style="display: block; margin: 0 auto;" height="100" />
            </td>
            <td>
              <h4><label style="color: ${textColor};">&nbsp;&nbsp;${msg}&nbsp;&nbsp;</label></h4>
            </td>
            </tr></table>
          </div>
        `
      });
    }
  }

  /**
   * @param msg 
   * @param {swalType} icons
   * * 'question1' - Aceptar / Cancelar
   * * 'question2' - Si / No
   * * 'error' 
   * * 'warning' 
   * * 'info' 
   * * 'success' 
   * * 'loading' 
   * * 'input' 
   * * 'text' 
   * * 'select'
   * @param title 
   * @param listOptions 
   * @returns {Promise<any>}
   */
  async messageBimbo(msg: string, icons: swalType, title: string, listOptions: string[] = []) {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    let colorMessage = this.userLogin.ColorMessage;
    let textColor = colorMessage === false ? 'DarkBlue' : 'White';
    let Toast;
    if (icons === 'loading') {
      Toast = Swal.mixin({
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/bimboworld.gif" alt="bimboworld.gif" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        position: 'center',
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : 'LightSlateGray',
      });
    } else {
      Toast = Swal.mixin({
        position: 'center',
        width: '500px',
        allowOutsideClick: false,
      });
    }
    if (icons === 'question1') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? 'DarkBlue' : 'White';
      const result = await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : 'DarkBlue',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Aceptar',
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> &nbsp; Cancelar'
      });
      return result.isConfirmed;
    }
    if (icons === 'question2') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? '#2b94d6ff' : 'White';
      const result = await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : '#2b94d6ff',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#073f9fff',
        cancelButtonColor: '#d33',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Si',
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> &nbsp; No'
      });
      return result.isConfirmed;
    }
    if (icons === 'error') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? 'Crimson' : 'White';
      await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : 'Crimson',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Aceptar',
      });
    }
    if (icons === 'warning') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? 'DarkOrange' : 'White';
      await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : 'DarkOrange',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Aceptar',
      });
    }
    if (icons === 'info') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? 'SteelBlue' : 'White';
      await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : 'SteelBlue',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Aceptar',
      });
    }
    if (icons === 'success') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? 'DarkGreen' : 'White';
      await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : '#0d7000',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> &nbsp; Aceptar',
      });
    }
    if (icons === 'input') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? '#680070ff' : 'White';
      const { value: swalValue } = await Toast.fire({
        background: colorMessage === false ? 'WhiteSmoke' : '#680070ff',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        input: "number",
        inputValue: '',
        confirmButtonText: ' &nbsp; Aceptar',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: ' &nbsp; Cancelar',
        inputAttributes: {
          style: colorMessage === false ? 'color: #680070ff;' : 'color: white;' 
        },
        inputValidator: (value) => {
          if (!value) {
            return "Debe ingresar un número";
          }
        }
      });
      return swalValue;
    }
    if (icons === 'text') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? '#044147ff' : 'White';
      const { value: swalValue } = await Swal.fire({
        background: colorMessage === false ? 'WhiteSmoke' : '#006770ff',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        input: "text",
        inputPlaceholder: '',
        inputAttributes: {
          style: colorMessage === false ? 'color: #044147ff;' : 'color: white;' 
        },
        confirmButtonText: ' &nbsp; Aceptar',
        showCancelButton: true,
        allowOutsideClick: false,
        inputValidator: (value) => {
          if (!value) {
            return "Debe ingresar un valor.";
          }
        }
      });
      return swalValue;
    }
    if (icons === 'select') {
      const randomIndex = Math.floor(Math.random() * 7) + 1;
      textColor = colorMessage === false ? '#670788ff' : 'White';
      const { value: listIndex } = await Swal.fire({
        background: colorMessage === false ? 'WhiteSmoke' : '#670788ff',
        html: `
          <div style="margin-bottom: 16px; text-align: center;">
            <h2><label style="color: ${textColor};">${title}</label></h2>
          </div>
          <img src="../assets/img/osito${randomIndex}.png" alt="osito${randomIndex}" style="display: block; margin: 0 auto;" height="200" />
          <div style="margin-top: 16px; text-align: center;">
            <h4><label style="color: ${textColor};">${msg}</label></h4>
          </div>
        `,
        input: "select",
        inputOptions: listOptions,
        inputPlaceholder: "Seleccione un elemento",
        inputAttributes: {
          style: colorMessage === false ? 'color: #670788ff;' : 'color: white;',
        },
        confirmButtonText: ' &nbsp; Aceptar',
        showCancelButton: true,
        allowOutsideClick: false,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value === '') {
              resolve("Debe seleccionar un elemento.");
            } else {
              resolve(void 0);
            }
          });
        }
      });
      return listIndex;
    }
  }

  async LoadingAlert(title = 'Cargando...', html = 'Por favor espere...') {
    await this.messageBimbo(html, 'loading', title);
  }

  /**Muestra una alerta de confirmacion asyncrona, se puede usar con await
   * @param title Titulo de la alerta
   * @param html Mensaje de la alerta
   */
  async ConfirmAlert(title: string = "Confirmación", html: string = '¿Desea confirmar la acción?'): Promise<boolean> {
    return await this.messageBimbo(html, 'question2', title);
  }

  /**
   * Obtiene la suscripcion del canal especificado, si no existe lo crea
   * @param channelName Nombre del canal al que se desea suscribir
   */
  subscribeToChannel<type>(channelName: string): Observable<type> {
    //inicializo la lista de canales si no existe
    if (!this.notifyChannels) {
      this.notifyChannels = [];
    }
    //inicializo el canal si no existe
    let channel = this.notifyChannels.find(x => x.ChannelName === channelName);
    if (!channel) {
      channel = { ChannelName: channelName, Subject: new ReplaySubject<type>() };
      this.notifyChannels.push(channel);
    }
    return channel.Subject.asObservable();
  }

  /**
   * Finaliza y elimina la suscripcion del canal especificado
   * @param channelName Nombre del canal al que se desea eliminar la suscripcion
   */
  unsubscribeChannel(channelName: string): void {
    //inicializo la lista de canales si no existe
    if (!this.notifyChannels) {
      return;
    }
    //busco el canal y lo elimino
    let channel = this.notifyChannels.find(x => x.ChannelName === channelName);
    if (channel) {
      let channelIdx = this.notifyChannels.findIndex(x => x.ChannelName === channelName);
      channel.Subject.complete();
      channel.Subject.unsubscribe();
      this.notifyChannels.splice(channelIdx, 1);
    }

  }

  /**
   * Envia un mensaje al canal especificado
   * @param channelName Nombre del canal al que se enviara el mensaje
   * @param message Objeto que se enviara en el mensaje
   */
  notifyChannel(channelName: string, message: any): void {
    let channel = this.notifyChannels.find(x => x.ChannelName === channelName);
    if (channel) {
      channel.Subject.next(message);
    }
  }

}

export type toastIcon = 'error' | 'warning' | 'info' | 'success' | 'loading';
export type swalType = 'question1' | 'question2' | 'error' | 'warning' | 'info' | 'success' | 'loading' | 'input' | 'text' | 'select';

export interface subjectType {
  ChannelName: string;
  Subject: ReplaySubject<any>;
}